import {
  Component,
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { clone, KreFormFieldConfig } from "@kre-form/core";
import { IBusinessTable } from "../../tools/util";
import * as _ from "lodash";

@Component({
  selector: "kreform-design-table",
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.less"],
})
export class KreFormDesignTable implements OnInit, OnChanges, OnDestroy {
  @Input() tableType: string = "";
  @Input() businessTable: IBusinessTable = {
    primary: {},
    child: {
      single: [],
      multiple: [],
    },
  };
  @Input() fieldConfig: KreFormFieldConfig = {};

  tableData = [];

  mapOfCheckedId: { [key: string]: boolean } = {};
  tableScroll = {
    y: "360px",
    x: "950px",
  };
  constructor() {}

  ngOnInit() {
    this.initTableData();
  }

  ngOnChanges(changes: SimpleChanges) {}

  ngOnDestroy() {}

  initTableData() {
    this.tableData = [];
    this.mapOfCheckedId = {};
    let business = clone(this.businessTable);

    let tables: any = [];
    if (!business) return;
    if (this.tableType === "single") {
      if (business.primary && business.primary != null) {
        tables = [...tables, business.primary];
      }
      if (
        business.child &&
        business.child != null &&
        business.child.single &&
        business.child.single != null &&
        business.child.single.length > 0
      ) {
        tables = tables.concat(business.child.single);
      }
    } else if (this.tableType === "multiple") {
      if (
        business.child &&
        business.child != null &&
        business.child.multiple &&
        business.child.multiple != null &&
        business.child.multiple.length > 0
      ) {
        business.child.multiple.forEach((table: any) => {
          if (table.tableCode === this.fieldConfig.tableCode) {
            tables = [table];
          }
        });
      }
    }
    this.tableData = tables;
  }
}
